import { z } from 'zod'

import {
  apiKeyCreateArgsSchema,
  apiKeyListArgsSchema,
  apiKeyListResponseSchema,
  apiKeySchema,
  apiKeyUpdateByIdArgsSchema,
  apiKeyVenuePermissionSchema,
} from './schemas/apiKey'
import { ApiKeyStatus } from './constants/apiKeys'

export type ApiKey = z.infer<typeof apiKeySchema>
export type ApiKeyVenuePermission = z.infer<typeof apiKeyVenuePermissionSchema>

export type ApiKeyListArgs = z.infer<typeof apiKeyListArgsSchema>
export type ApiKeyCreateArgs = z.infer<typeof apiKeyCreateArgsSchema>
export type ApiKeyUpdateByIdArgs = z.infer<typeof apiKeyUpdateByIdArgsSchema>

//responses
export type ApiKeyListResponse = z.infer<typeof apiKeyListResponseSchema>

export function getApiKeyStatus(
  expirationDate?: Date | number | string | null
): ApiKeyStatus {
  if (!expirationDate || expirationDate === -1 || expirationDate === '-1') {
    return ApiKeyStatus.NEVER_EXPIRES
  }

  const expDate = new Date(expirationDate)
  if (Number.isNaN(expDate.getTime())) return ApiKeyStatus.EXPIRED

  return expDate > new Date() ? ApiKeyStatus.ACTIVE : ApiKeyStatus.EXPIRED
}

export function formatApiKeyExpirationDate(
  expirationDate?: Date | number | string | null
): string {
  if (!expirationDate || expirationDate === -1 || expirationDate === '-1') {
    return 'Never'
  }

  const expDate = new Date(expirationDate)
  if (Number.isNaN(expDate.getTime())) return 'Invalid date'

  return expDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
